import Box from 'components/Containers/Box';
import CenterAlignBox from 'components/Containers/CenterAlignBox';
import { Row } from 'components/Containers/Row/Row';
import RowBox from 'components/Containers/RowBox';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import SpreadBox from 'components/Containers/SpreadBox';
import { Button } from 'components/form/Button';
import Label from 'components/form/Label/Label';
import { Image } from 'components/Image/Image';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useSeenModulePixel } from 'hook/helper.hook';
import { KYC_SOFT_FAIL } from 'types/morph.pagePosition.constants';
import { BANKING_VERTICAL } from 'types/mrph.vertical.constants';
import { startCognigyChat } from 'externals/_misc/cognigyChat';
import { useLogger } from 'hook/error.hook';
import './KYCSoftFail.scss';

const KYCSoftFail = props => {
  const logger = useLogger({ name: 'KYCSoftFail', categories: ['cash'] });
  const atr = getViewModuleTrackingAttributes({
    pagePosition: KYC_SOFT_FAIL,
    vertical: BANKING_VERTICAL,
    modulePosition: props.modulePosition,
  });
  const seenPixel = useSeenModulePixel(atr);

  const onClickCTA = () => {
    props.eventHandler(CLICK, {
      ...atr,
      'Click Type': 'Customer Service Chat',
      Vertical: BANKING_VERTICAL,
    });
    startCognigyChat(props).catch(e => {
      logger.showError(e.message);
    });
  };

  return (
    <>
      <SectionContainer>
        {seenPixel}
        <Row>
          <SpreadBox className="KYCSoftFail">
            <Box widthClassName="format50 m-format100">
              <Label type="H3 mH5" className="padB24">
                Almost there! Verify your information.
              </Label>
              <Label type="Body-1" className="padB16">
                You will receive an email from us within 24-48 hours with next
                steps for opening your Sesame Cash account.
              </Label>
              <Label type="Body-1" className="padB24">
                If you do not receive an email or have further questions, you
                can chat with our support team.
              </Label>
              <CenterAlignBox className="d-hide">
                <Image imgClass="kycSoftFailHeroimg" />
              </CenterAlignBox>
              <div className="padB0 m-padB24" />
              <Button onClick={onClickCTA} mrphType="primary">
                Chat With Support
              </Button>
            </Box>
            <RowBox className="t-hide" justifyEnd widthClassName="format50">
              <Image imgClass="kycSoftFailHeroimg" />
            </RowBox>
          </SpreadBox>
        </Row>
      </SectionContainer>
    </>
  );
};

export default KYCSoftFail;
